import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LessonsState } from '../reducers/lessons.reducer';
import { LESSONS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<LessonsState>(LESSONS_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: LessonsState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: LessonsState) => state.loading);
export const selectLessons = createSelector(selectState, (state: LessonsState) => state.lessons);
export const selectTotal = createSelector(selectState, (state: LessonsState) => state.total);
export const selectPage = createSelector(selectState, (state: LessonsState) => state.page);
export const selectLimit = createSelector(selectState, (state: LessonsState) => state.limit);
export const selectLastParams = createSelector(selectState, (state: LessonsState) => state.lastParams);
